@if (data?.addToWallet || data.enableClose) {
	<button matMiniFab (click)="dialogRef.close()"
	        style="position: absolute; inset-inline-end: 0.5rem; inset-block-start: 0.5rem; z-index: 10;">
		<mat-icon>close</mat-icon>
	</button>

}

<iframe #exIframe id="ex_iframe" [src]="trustedIframeUrl" (load)="onFrameLoaded($event)" allow="payment" seamless="seamless"></iframe>
